export abstract class ValidationService {
  abstract showError(data: any): string[];
}
